import {
  SET_AUTH_INFORMATION,
  SET_CLIENT_INFORMATION,
  SET_LOADER_VISIBILITY,
  SET_ENGAGEMENT_COUNT,
  SET_JWT_AUTH_TOKEN,
  SET_NOTIFICATION_SUMMARY,
  SET_RISK_PROFILE_DATA,
  SET_CLIENT_Session,
} from "../../../helpers/vuex-constants";
export default {
  [SET_CLIENT_INFORMATION](state, payload) {
    state.clientInformation = payload;
  },
  [SET_CLIENT_Session](state, payload) {
    state.sessionId = payload;
  },
  [SET_AUTH_INFORMATION](state, payload) {
    state.authInformation = payload;
    state.isClientInformationLoad = true;
  },
  [SET_NOTIFICATION_SUMMARY](state, payload) {
    state.notificationSummary = payload;
  },
  [SET_LOADER_VISIBILITY](state, payload) {
    state.isShowLoader = payload;
  },
  [SET_ENGAGEMENT_COUNT](state, payload) {
    state.engagementData = payload;
  },
  [SET_JWT_AUTH_TOKEN](state, payload) {
    state.jwtToken = payload;
  },
  [SET_RISK_PROFILE_DATA](state, payload) {
    state.riskprofiledata = payload;
  },
};
